
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/the-latest",
      function () {
        return require("private-next-pages/the-latest/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/the-latest"])
      });
    }
  